import { Audit_Log } from "./audit_log";

export class ManagedCylinderInformation {
  product_Type_Id: number = 0;
  cyl_Size_Id: number = 0;
  target: string | number;
  daily_Avg_Usage?: string | number;
  minimum?: string | number;
  audit_Log: Audit_Log = new Audit_Log();
  location_Id: number = 0;
  is_Edit?: boolean;
  managed_Cyl_Info_ID: number;

  constructor(init?: Partial<ManagedCylinderInformation>) {
    this.product_Type_Id = null;
    this.cyl_Size_Id = null;
    this.target = null;
    this.daily_Avg_Usage = null;
    this.minimum = null;
    this.audit_Log = new Audit_Log();
    this.location_Id = null;
    this.is_Edit = false;

    Object.assign(this, init);
  }
}